import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue } from "vue-facing-decorator";
import Icon from "@/components/icon/Icon.vue";
import StandardButton from "@/components/buttons/StandardButton.vue";
let AIModePicker = class AIModePicker extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "aiFiles", void 0);
    _defineProperty(this, "mode", 'ALL_CONTENT');
    _defineProperty(this, "oldDocumentJobID", "");
    _defineProperty(this, "newDocumentJobID", "");
  }
  get canCompare() {
    return this.aiFiles.length >= 2;
  }
  get canValidate() {
    switch (this.mode) {
      case 'ALL_CONTENT':
      case 'SYNTHESIS':
      case 'ROLE':
        return true;
      case 'COMPARISON':
        return !!this.oldDocumentJobID && !!this.newDocumentJobID && this.oldDocumentJobID !== this.newDocumentJobID;
    }
    return false;
  }
  setMode(newMode) {
    this.mode = newMode;
    if (newMode === 'COMPARISON' && !this.oldDocumentJobID && this.aiFiles.length >= 2) {
      this.oldDocumentJobID = this.aiFiles[0].jobID;
      this.newDocumentJobID = this.aiFiles[1].jobID;
    }
  }
  /** Swap the old (reference) and new (to compare) versions. */
  swapVersions() {
    const tmp = this.oldDocumentJobID;
    this.oldDocumentJobID = this.newDocumentJobID;
    this.newDocumentJobID = tmp;
  }
  onValidate() {
    if (!this.canValidate) return;
    const payload = {
      mode: this.mode
    };
    if (this.mode === 'COMPARISON') {
      payload.oldDocumentJobID = this.oldDocumentJobID;
      payload.newDocumentJobID = this.newDocumentJobID;
    }
    this.$emit('modeSelected', payload);
  }
  onBack() {
    this.$emit('back');
  }
};
__decorate([Prop({
  required: true
})], AIModePicker.prototype, "aiFiles", void 0);
AIModePicker = __decorate([Component({
  components: {
    Icon,
    StandardButton
  }
})], AIModePicker);
export default AIModePicker;